module.exports = __webpack_public_path__ + "italy.svg?612e617f5d72975e63e53d793d757785";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/italy.svg
// module id = 197
// module chunks = 10